// extracted by mini-css-extract-plugin
export var banner = "ProspectBanner_banner__S1wQ4";
export var navLink = "ProspectBanner_navLink__8Awd0";